export default __webpack_public_path__ + "static/media/DJI_0989.MP4.00_01_14_03.Still001.6ea2208a.jpg";